import { Flex, Grid, styled } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

export const columnSize = '--column-size';

export const styles = {
  Card: styled(Flex, {
    backgroundColor: '$backgroundSecondary',
    borderRadius: '$medium',
    boxShadow: '$2',
    flexDirection: 'column',
    gap: '$3',
    padding: '$4',
  }),

  CardSkeleton: styled(Skeleton, {
    height: 'calc($23 * 2)',
    backgroundColor: '$nonInteractiveAltAuxiliar',
  }),

  Wrapper: styled(Grid, {
    [columnSize]: '4',

    gap: '$4',

    '@tablet': {
      gridTemplateColumns: `repeat(2, minmax(auto, 1fr))`,
    },

    '@desktop': {
      gridTemplateColumns: `repeat(var(${columnSize}), minmax(auto, 1fr))`,
    },
  }),
};

export default styles;
